'use strict';

function checkMimeType(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles)
            ? acceptedFiles
            : acceptedFiles.split(",");
        var fileName_1 = file.name || "";
        var mimeType_1 = file.type || "";
        var baseMimeType_1 = mimeType_1.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function (type) {
            var validType = type.trim();
            if (/^\*(\/\*)?$/.test(type)) {
                return true;
            }
            if (validType.charAt(0) === ".") {
                var lowerFileName_1 = fileName_1.toLowerCase();
                var lowerType = validType.toLowerCase();
                var affixList = [lowerType];
                if (lowerType === ".jpg" || lowerType === ".jpeg") {
                    affixList = [".jpg", ".jpeg"];
                }
                return affixList.some(function (affix) { return lowerFileName_1.endsWith(affix); });
            }
            if (/\/\*$/.test(validType)) {
                return baseMimeType_1 === validType.replace(/\/.*$/, "");
            }
            if (mimeType_1 === validType) {
                return true;
            }
            if (/^\w+$/.test(validType)) {
                return true;
            }
            return false;
        });
    }
    return true;
}

exports.checkMimeType = checkMimeType;
